module.exports = __webpack_public_path__ + "static/media/green.5efb34d7.png";